<div id="fuse-shortcuts" #shortcuts>

    <div class="shortcuts-mobile-toggle" *ngIf="!mobileShortcutsPanelActive" fxLayout="row" fxLayoutAlign="start center"
         fxHide fxShow.lt-md>
        <button mat-icon-button (click)="showMobileShortcutsPanel()">
            <mat-icon class="amber-600-fg">star</mat-icon>
        </button>
    </div>

    <div class="shortcuts" fxLayout="row" fxHide fxShow.gt-sm>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">

            <div fxLayout="row" fxLayoutAlign="start center">

                <div class="w-40 h-40 p-4" fxLayout="row" fxLayoutAlign="center center"
                     *ngFor="let favorisItem of shortcutItems">

                    <a mat-icon-button [matTooltip]="favorisItem.shortcutItem.title" [routerLink]="favorisItem.shortcutItem.url">
                        <mat-icon class="secondary-text" *ngIf="favorisItem.shortcutItem.icon">{{favorisItem.shortcutItem.icon}}</mat-icon>
                        <span *ngIf="!favorisItem.shortcutItem.icon" class="h2 secondary-text text-bold">
                            {{ ( favorisItem.shortcutItem.title || '').substr(0, 1).toUpperCase()}}

                        </span>
                    </a>

                </div>

                <button mat-icon-button [matMenuTriggerFor]="addMenu" matTooltip="{{'FAVORIS.ADD_SHORTCUT' | translate}}"
                        (menuOpened)="onMenuOpen()">
                    <mat-icon class="amber-600-fg">star</mat-icon>
                </button>

            </div>

            <div class="shortcuts-mobile-close" fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.lt-md>
                <button mat-icon-button (click)="hideMobileShortcutsPanel()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

        </div>

        <mat-menu #addMenu="matMenu" class="w-540">

            <mat-form-field class="px-16 w-100-p" (click)="$event.stopPropagation()" floatLabel="never">
                <input #searchInput matInput placeholder="{{'FAVORIS.SEARCH_TEXT' | translate}}" (input)="search($event)">
            </mat-form-field>

            <mat-divider></mat-divider>

            <mat-nav-list *ngIf="!searching" class="scrollable-list" fusePerfectScrollbar>

                <mat-list-item *ngFor="let favorisItem of shortcutItems"
                [routerLink]="favorisItem.shortcutItem.url">

                    <div class="w-100-p" fxLayout="row" fxLayoutAlign="start center">

                        <mat-icon mat-list-icon class="mr-8 secondary-text" *ngIf="favorisItem.shortcutItem.icon">
                            {{ favorisItem.shortcutItem.icon }}
                        </mat-icon>

                        <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" fxLayout="row"
                              fxLayoutAlign="center center" *ngIf="!favorisItem.shortcutItem.icon">
                            {{(favorisItem?.shortcutItem?.title || '').substr(0, 1).toUpperCase()}}
                        </span>

                        <p matLine fxFlex>{{favorisItem.shortcutItem.title}}</p>

                        <mat-icon class="ml-8 amber-fg" (click)="toggleShortcut($event, favorisItem.shortcutItem)">star</mat-icon>

                    </div>

                </mat-list-item>

                <mat-list-item *ngIf="shortcutItems.length === 0">
                    <p>
                        <small>{{'FAVORIS.NO_SHORTCUTS' | translate}} </small>
                    </p>
                </mat-list-item>

            </mat-nav-list>

       <mat-nav-list *ngIf="searching" class="scrollable-list" fusePerfectScrollbar>

                <mat-list-item *ngFor="let navigationItem of filteredNavigationItems"
                [routerLink]="navigationItem.url">
                               <div class="w-100-p" fxLayout="column" >

                                
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex>
                                    
                                    <mat-icon mat-list-icon class="mr-2 secondary-text" *ngIf="navigationItem.icon">
                                        {{ navigationItem.icon }}
                                    </mat-icon>
                        
                                    <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" 
                                          fxLayout="row" fxLayoutAlign="center center" *ngIf="!navigationItem.icon">
                                        {{ navigationItem.title.substr(0, 1).toUpperCase() }}
                                    </span>
                        <div class="w-100-p" fxLayout="column" >
                                    <p matLine class="title-text mb-0" >{{ navigationItem.title }}</p>
                                    <p matLine class="subtitle-text navigation-path">
                                        {{ getFullPath(navigationItem) }}
                                    </p>
                                     
                                </div>
                                    <mat-icon class="ml-8 amber-fg"  (click)="toggleShortcut($event, navigationItem)" *ngIf="isInShortcuts(navigationItem)">star</mat-icon>
                                    <mat-icon class="ml-8"    (click)="toggleShortcut($event, navigationItem)"*ngIf="!isInShortcuts(navigationItem)" >star_border</mat-icon>
                              
                                </div>
                        
                             
                               
                            </div>
                        

                </mat-list-item>

            </mat-nav-list>

        </mat-menu>

    </div>

</div>
